import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class TransportDriver extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/driver`)
  }

  approve(id, data, showProgress) {
    return this._request({
      action: `${id}/approve`,
      method: 'PATCH',
      body: data,
      showProgress
    })
  }

  blackList(id, model, showProgress) {
    return this._request({
      action: `${id}/blackList/set`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  revertBlackList(id, showProgress) {
    return this._request({
      action: `${id}/blackList/unset`,
      method: 'PATCH',
      showProgress
    })
  }

  delete(driverId, model, showProgress) {
    return this._request({
      action: driverId,
      method: 'DELETE',
      body: model,
      showProgress
    })
  }
}
